exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__FieldLabel__root {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  transition: -webkit-transform 0.3s ease;\n  transition: transform 0.3s ease;\n  transition: transform 0.3s ease, -webkit-transform 0.3s ease;\n  -webkit-transform: translate(0, 0) scale(1);\n          transform: translate(0, 0) scale(1);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n  @media screen and (prefers-reduced-motion: reduce) {.DS__FieldLabel__root {\n    transition: none\n}\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__FieldLabel__root"
};